module.exports = __webpack_public_path__ + "img/mail.526ebdef.svg";